import { Dialog, Plugin, View } from "ckeditor5";
// @ts-ignore
import i18next from "i18n/i18n";
// @ts-ignore
import Messenger from "messaging/messenger";

export default class SummarizeResponseUI extends Plugin {
  public static get requires() {
    return [Dialog];
  }

  public static get pluginName(): string {
    return "SummarizeResponseUI";
  }

  public showSummaryDialog(summaryText: string): void {
    const editor = this.editor;
    const dialog: Dialog = editor.plugins.get(Dialog);
    const summaryView = new View(editor.locale);

    summaryView.setTemplate({
      tag: "div",
      attributes: {
        class: ["ak-response-summary-dialog-body"],
      },
      children: [
        {
          tag: "pre",
          attributes: {
            class: ["ak-response-summary-text", "ck-reset_all"],
          },
        },
      ],
    });

    summaryView.on("render", () => {
      const container = summaryView.element!.querySelector(
        ".ak-response-summary-text",
      ) as HTMLPreElement | null;

      if (container) {
        container.textContent = summaryText;
      }
    });

    const copySummary = async () => {
      try {
        await navigator.clipboard.writeText(summaryText);
      } catch (e) {
        console.error("Copy summary failed", e);
        Messenger.okDialog(i18next.t("ai.error.summarizeResponseCopyError"));
      }
    };

    dialog.show({
      id: "ak-response-summary-dialog",
      className: "ak-response-summary-dialog",
      title: i18next.t("ai.summarize.dialogTitle"),
      content: summaryView,
      isModal: true,
      actionButtons: [
        {
          label: i18next.t("ai.summarize.copyToClipboard"),
          class: "ck-button-action",
          withText: true,
          onExecute: () => {
            copySummary().then((_) => dialog.hide());
          },
        },
        {
          label: i18next.t("common.cancel"),
          class: "ck-button-cancel",
          withText: true,
          onExecute: () => dialog.hide(),
        },
      ],
    });
  }
}
